export class TylerEagleRequest
{
    clientKey : string = "";
    transactionID : string = "";
    amount : string = "";
    description : string = "";
    redirectURL : string = "";
    postbackURL  : string = "";
    language : string = "";
    getToken : string = "";
    payorName  : string = "";
    nexusRedirectUrl: string = "";
}

export class TylerEagleCancel
{
    postbackURL : string = "";
}